// src/pages/Login.js
import React, { useState } from "react";
import { auth } from "../firebase"; 
import { signInWithEmailAndPassword } from "firebase/auth";
import { Container, TextField, Button, Typography, Box, Paper } from "@mui/material"; // Aggiunto Paper
import { useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const location = useLocation();
  const [error, setError] = useState(location.state?.error || "");
  const { currentUser } = useAuth();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
    if (error) setError(""); 
  };

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
    if (error) setError("");
  };

  const handleLogin = async e => {
    e.preventDefault();
    setError(""); 
    if (currentUser) {
      await auth.signOut();
    }
    try {
      await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
      if (err.code === 'auth/wrong-password' || err.code === 'auth/user-not-found' || err.code === 'auth/invalid-credential') {
        setError("Credenziali non valide");
      } else {
        setError("Si è verificato un errore. Riprova.");
      }
    }
  };

  // --- STILI ---
  // Definisco gli stili dei TextField qui per non sporcare troppo il JSX
  const textFieldStyle = {
    "& .MuiOutlinedInput-root": {
      color: "#fff", // Testo input bianco
      "& fieldset": { borderColor: "rgba(255, 255, 255, 0.3)" }, // Bordo default
      "&:hover fieldset": { borderColor: "rgba(255, 255, 255, 0.5)" }, // Bordo hover
      "&.Mui-focused fieldset": { borderColor: "#00d4ff" }, // Bordo focus (Ciano neon)
    },
    "& .MuiInputLabel-root": { color: "rgba(255, 255, 255, 0.7)" }, // Label grigia
    "& .MuiInputLabel-root.Mui-focused": { color: "#00d4ff" }, // Label focus
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        // Background Gradiente Scuro "Cyberpunk/Modern"
        background: "linear-gradient(135deg, #0f0c29 0%, #302b63 50%, #24243e 100%)",
        padding: 2,
      }}
    >
      <Container maxWidth="xs">
        <Paper
          elevation={24}
          sx={{
            p: 4,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            // --- GLASSMORPHISM MAGIC ---
            background: "rgba(255, 255, 255, 0.05)", // Molto trasparente
            backdropFilter: "blur(20px)", // Sfocatura potente
            WebkitBackdropFilter: "blur(20px)", // Supporto Safari
            border: "1px solid rgba(255, 255, 255, 0.1)", // Bordo sottile
            borderRadius: "16px",
            boxShadow: "0 8px 32px 0 rgba(0, 0, 0, 0.37)", // Ombra profonda
          }}
        >
          {/* Titolo */}
          <Typography component="h1" variant="h5" sx={{ color: "#fff", fontWeight: "bold", mb: 3, letterSpacing: 0 }}>
            SOUL FIT HYBRID CENTER
          </Typography>
          <Typography component="h1" variant="h5" sx={{ color: "#fff", fontWeight: "bold", mb: 3, letterSpacing: 1 }}>
            ADMIN LOGIN
          </Typography>

          <Box component="form" onSubmit={handleLogin} sx={{ mt: 1, width: '100%' }}>
            <TextField
              margin="normal"
              required
              fullWidth
              label="Email"
              type="email"
              value={email}
              onChange={handleEmailChange}
              sx={textFieldStyle}
              variant="outlined"
            />
            <TextField
              margin="normal"
              required
              fullWidth
              label="Password"
              type="password"
              value={password}
              onChange={handlePasswordChange}
              sx={textFieldStyle}
              variant="outlined"
            />
            
            {error && (
              <Typography color="error" align="center" sx={{ mt: 2, bgcolor: 'rgba(255,0,0,0.1)', p: 1, borderRadius: 1 }}>
                {error}
              </Typography>
            )}

            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                mt: 4,
                mb: 2,
                py: 1.5,
                fontWeight: "bold",
                background: "linear-gradient(45deg, #2196F3 30%, #21CBF3 90%)", // Gradiente sul bottone
                boxShadow: "0 3px 5px 2px rgba(33, 203, 243, .3)",
                transition: "0.3s",
                "&:hover": {
                   transform: "scale(1.02)",
                   boxShadow: "0 6px 10px 4px rgba(33, 203, 243, .4)",
                }
              }}
            >
              ACCEDI
            </Button>
          </Box>
        </Paper>
      </Container>
    </Box>
  );
}